import { BreakdownDropdownOption, ReportTypeLevelKey } from '../types'
import { ReportConfigurationBreakdown } from '../enums/report-configuration-breakdown'
import { ensureDomain, ensureOrg } from '../helpers/conditions'
import { PlatformLevel } from '../enums/platform-level'

export const DEFAULT_BREAKDOWN = {
    value: ReportConfigurationBreakdown.NONE,
    label: 'None',
}

export const CHANNEL_BREAKDOWN = { value: ReportConfigurationBreakdown.CHANNEL, label: 'Delivery Channel' }
export const PLACEMENT_BREAKDOWN = { value: ReportConfigurationBreakdown.PLACEMENT, label: 'Device Type' }
export const PLACEMENT_CHANNEL_BREAKDOWN = {
    value: ReportConfigurationBreakdown.PLACEMENT_CHANNEL,
    label: 'Device Type & Channel',
    condition: ensureOrg,
}

const ORG_DOMAIN_BREAKDOWN = {
    value: ReportConfigurationBreakdown.DOMAIN,
    label: 'Domain',
    condition: ensureOrg,
}
const ORG_DOMAIN_CHANNEL_BREAKDOWN = {
    value: ReportConfigurationBreakdown.DOMAIN_CHANNEL,
    label: 'Domain & Delivery Channel',
    condition: ensureOrg,
}
const ORG_DOMAIN_CHANNEL_PLACEMENT_BREAKDOWN = {
    value: ReportConfigurationBreakdown.DOMAIN_CHANNEL_PLACEMENT,
    label: 'Domain, Channel & Device Type',
    condition: ensureOrg,
}

export const GENERIC_BREAKDOWNS: BreakdownDropdownOption[] = [
    { value: ReportConfigurationBreakdown.BROWSER, label: 'Browser', condition: ensureDomain },
    {
        value: ReportConfigurationBreakdown.BROWSER_PLACEMENT,
        label: 'Browser & Device Type',
        condition: ensureDomain,
    },
    {
        value: ReportConfigurationBreakdown.BROWSER_PLACEMENT_OPERATING_SYSTEM,
        label: 'Browser, Device Type, & OS',
        condition: ensureDomain,
    },
    {
        value: ReportConfigurationBreakdown.BROWSER_OPERATING_SYSTEM,
        label: 'Browser & OS',
        condition: ensureDomain,
    },
    { value: ReportConfigurationBreakdown.OPERATING_SYSTEM, label: 'OS', condition: ensureDomain },
    PLACEMENT_BREAKDOWN,
    {
        value: ReportConfigurationBreakdown.PLACEMENT_OPERATING_SYSTEM,
        label: 'Device Type & OS',
        condition: ensureDomain,
    },
    CHANNEL_BREAKDOWN,
]

export const TIMEZONE_BREAKDOWNS = [{ value: ReportConfigurationBreakdown.TIMEZONE, label: 'Time Zone' }]

export const BUTTON_BREAKDOWNS = [
    { value: ReportConfigurationBreakdown.BUTTON, label: 'Button', condition: ensureDomain },
]

export const BREAKDOWN_DROPDOWN_OPTIONS: Partial<Record<ReportTypeLevelKey, BreakdownDropdownOption[]>> = {
    DELIVERY_ORGANIZATION: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN, PLACEMENT_BREAKDOWN, PLACEMENT_CHANNEL_BREAKDOWN],
    DELIVERY_DOMAIN: [DEFAULT_BREAKDOWN, ...BUTTON_BREAKDOWNS, ...GENERIC_BREAKDOWNS, PLACEMENT_CHANNEL_BREAKDOWN],
    DELIVERY_NOTIFICATION: [
        DEFAULT_BREAKDOWN,
        // org breakdowns
        ORG_DOMAIN_BREAKDOWN,
        ...BUTTON_BREAKDOWNS,
        ...GENERIC_BREAKDOWNS,
        ORG_DOMAIN_CHANNEL_BREAKDOWN,
        ORG_DOMAIN_CHANNEL_PLACEMENT_BREAKDOWN,
        PLACEMENT_CHANNEL_BREAKDOWN,
    ],
    DELIVERY_TEST: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN],
    DELIVERY_CAMPAIGN: [DEFAULT_BREAKDOWN],
    DELIVERY_SEGMENT: [DEFAULT_BREAKDOWN],
    DELIVERY_KEYWORD: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN],
    SUBSCRIBER_ORGANIZATION: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN, PLACEMENT_BREAKDOWN, PLACEMENT_CHANNEL_BREAKDOWN],
    SUBSCRIBER_DOMAIN: [DEFAULT_BREAKDOWN, ...GENERIC_BREAKDOWNS],
    SUBSCRIBER_PROMPT: [DEFAULT_BREAKDOWN, ...GENERIC_BREAKDOWNS],
    SUBSCRIBER_TEST: [DEFAULT_BREAKDOWN],
    PUB_NETWORK_DOMAIN: [DEFAULT_BREAKDOWN],
    MONTHLY_UNIQUES_DOMAIN: [
        DEFAULT_BREAKDOWN,
        PLACEMENT_BREAKDOWN,
        CHANNEL_BREAKDOWN,
        { ...PLACEMENT_CHANNEL_BREAKDOWN, condition: ensureDomain }, // <- override base condition for domain only report
    ],
    APP_MESSAGE_DOMAIN: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN, PLACEMENT_BREAKDOWN],
    APP_MESSAGE_APP_MESSAGE: [DEFAULT_BREAKDOWN, CHANNEL_BREAKDOWN, PLACEMENT_BREAKDOWN],
    LIVE_ACTIVITY_DOMAIN: [DEFAULT_BREAKDOWN],
    LIVE_ACTIVITY_ACTIVITY: [DEFAULT_BREAKDOWN],
}
